import { Link } from "react-router-dom";
import { Gift, CalendarHeart, Lock, Link2, Users as UsersIcon, Globe } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { SmartImage } from "@/components/SmartImage";

const privacyIcon = { public: Globe, link_only: Link2, friends: UsersIcon, private: Lock };

export const WishlistCard = ({ wishlist, delay = 0 }) => {
  const { t } = useLang();
  const PIcon = privacyIcon[wishlist.privacy] || Globe;
  const days = wishlist.event_date
    ? Math.ceil((new Date(wishlist.event_date) - new Date()) / 86400000)
    : null;
  return (
    <Link to={`/liste/${wishlist.wishlist_id}`} data-testid={`wishlist-card-${wishlist.wishlist_id}`}
      className="block bg-card rounded-2xl border border-border/50 overflow-hidden card-lift fade-up" style={{ animationDelay: `${delay}s` }}>
      <div className="aspect-[16/9] bg-secondary/60 relative">
        <SmartImage src={wishlist.cover_image} alt={wishlist.title} className="w-full h-full object-cover"
          fallback={<div className="w-full h-full flex items-center justify-center"><Gift size={32} className="text-muted-foreground/40" /></div>} />
        {days !== null && days >= 0 && (
          <span className="absolute top-3 right-3 bg-primary text-white text-xs font-semibold px-3 py-1 rounded-full flex items-center gap-1">
            <CalendarHeart size={12} /> {days === 0 ? t("today") : `${days} ${t("days_left")}`}
          </span>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-heading font-semibold truncate">{wishlist.title}</h3>
        <div className="flex items-center gap-3 mt-1.5 text-xs text-muted-foreground">
          <span className="flex items-center gap-1"><Gift size={12} /> {wishlist.item_count ?? 0} {t("items_count")}</span>
          <span className="flex items-center gap-1"><PIcon size={12} /></span>
        </div>
      </div>
    </Link>
  );
};
